/*
  cytoscape-html-node-label extension
  Allows attaching HTML labels to nodes via a callback API.
*/
;(function(){
  'use strict';

  function register(cytoscape) {
    if (!cytoscape) return;

    cytoscape('core', 'htmlNodeLabel', function(opts) {
      var cy = this;
      var options = Array.isArray(opts) ? opts : [];

      // Ensure overlay container exists
      var container = cy.container();
      var labelContainer = container.querySelector('.cy-html-node-label-container');
      if (!labelContainer) {
        labelContainer = document.createElement('div');
        labelContainer.className = 'cy-html-node-label-container';
        Object.assign(labelContainer.style, {
          position: 'absolute', top: 0, left: 0,
          width: '100%', height: '100%',
          pointerEvents: 'none'
        });
        container.appendChild(labelContainer);
      }

      function renderLabels() {
        // Clear old labels
        while (labelContainer.firstChild) {
          labelContainer.removeChild(labelContainer.firstChild);
        }
        // Render each spec
        options.forEach(function(opt) {
          var sel = opt.query || 'node';
          cy.elements(sel).forEach(function(ele) {
            var html = typeof opt.html === 'function' ? opt.html(ele) : opt.html;
            if (!html) return;
            var dom = typeof html === 'string'
              ? (function(){ var d = document.createElement('div'); d.innerHTML = html; return d.firstChild; })()
              : html;
            if (!dom) return;
            // Style and position: align with node label style
            dom.style.position = 'absolute';
            dom.style.pointerEvents = opt.enablePointerEvents ? 'auto' : 'none';
            labelContainer.appendChild(dom);
            // compute bounding box including labels and margins
            var bb = ele.renderedBoundingBox({ includeLabels: true });
            var bbX = bb.x1;
            var bbY = bb.y1;
            var bbW = bb.x2 - bb.x1;
            var bbH = bb.y2 - bb.y1;

            var w = dom.offsetWidth;
            var h = dom.offsetHeight;

            // determine alignment (with Cytoscape defaults)
            var halign = opt.halign || ele.css('text-halign') || 'center';
            var valign = opt.valign || ele.css('text-valign') || 'center';

            // compute position based on bounding box and element size
            var x = halign === 'left'
              ? bbX
              : halign === 'right'
                ? bbX + bbW - w
                : bbX + (bbW - w) / 2;
            var y = valign === 'top'
              ? bbY
              : valign === 'bottom'
                ? bbY + bbH - h
                : bbY + (bbH - h) / 2;

            // compute pivot for rotation relative to element
            var pivotX = halign === 'left'
              ? 0
              : halign === 'right'
                ? w
                : w / 2;
            var pivotY = valign === 'top'
              ? 0
              : valign === 'bottom'
                ? h
                : h / 2;

            // apply user-specified offsets
            var offsetX = opt.offsetX != null ? opt.offsetX : 0;
            var offsetY = opt.offsetY != null ? opt.offsetY : 0;
            x += offsetX;
            y += offsetY;

            // determine rotation for edges if autorotate is enabled
            var rot = 0;
            var textRotation = ele.css('text-rotation');
            if (!(ele.isNode && ele.isNode())) {
              if (textRotation === 'autorotate') {
                var srcPos = typeof ele.sourceEndpoint === 'function'
                  ? ele.sourceEndpoint()
                  : ele.source().renderedPosition();
                var tgtPos = typeof ele.targetEndpoint === 'function'
                  ? ele.targetEndpoint()
                  : ele.target().renderedPosition();
                rot = Math.atan2(tgtPos.y - srcPos.y, tgtPos.x - srcPos.x) * 180 / Math.PI;
              } else if (textRotation && textRotation !== 'none') {
                var numRot = parseFloat(textRotation);
                if (!isNaN(numRot)) {
                  rot = numRot;
                }
              }
            }

            dom.style.transformOrigin = pivotX + 'px ' + pivotY + 'px';
            dom.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + rot + 'deg)';
          });
        });
      }

      // update on pan, zoom, resize, and during node drag/position changes
      cy.on('pan zoom resize', renderLabels);
      // also update on grab, drag, free to handle interactive drags
      cy.on('grab drag free position', 'node', renderLabels);
      // also update on select/unselect when element style (e.g. border/shadow) changes
      cy.on('select unselect', renderLabels);
      // Initial render
      renderLabels();
      return cy;
    });
  }

  // CommonJS
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = register;
  }
  // AMD
  if (typeof define === 'function' && define.amd) {
    define('cytoscape-html-node-label', function(){ return register; });
  }
  // Global
  if (typeof window !== 'undefined' && window.cytoscape) {
    register(window.cytoscape);
  }
})();
